<div class="topbar">
  <div class="topbar-breadcrumbs">
    @if (breadcrumbs | async; as $breadcrumbs) {
    <div>
      @for (breadcrumb of $breadcrumbs; track breadcrumb; let i = $index) { @if
      (i > 0) {
      <span class="topbar-breadcrumbs-separator">‣</span>
      } @if (i < $breadcrumbs.length - 1) {
      <user-interaction
        [interaction]="breadcrumb.userInteraction"
        class="topbar-breadcrumbs-interaction"
      >
        <span [innerText]="breadcrumb.label"></span>
      </user-interaction>
      } @if (i === $breadcrumbs.length - 1) {
      <strong [innerText]="breadcrumb.label"></strong>
      } }
    </div>
    }
  </div>
  <nav class="topbar-meta_menu">
    <!-- isReady property represent if the UserFlow service has been initialized properly and if account is in a free state.
    isReady condition will be extended with paid accounts as soon we are ready with onboarding flows.
    -->
    @if (userOnboardingInitService.shouldShowOnboarding$ | async) {
    <!-- Use *ngIf/*ngElse pattern for the two progress states -->
    @if ((progress$ | async) < 100) {
    <app-userflow-trigger [@fadeAnimation]> </app-userflow-trigger>
    } @else { @if (hasFreeOnboarding$ | async) {
    <div [@fadeAnimation]>
      <span class="plan-title" [translate]="'plan.basic.title'"></span>
      <app-upgrade-button></app-upgrade-button>
    </div>
    } } } @if (showUpgradeCenter$ | async) {
    <app-upgrade-center-cta
      [onboardingProgress$]="progress$"
      style="margin: 2px 8px 0 0"
    ></app-upgrade-center-cta>
    }

    <ul>
      @for (navigationItem of metaMenuItems | sort : 'order'; track
      navigationItem) {
      <li class="topbar-meta_menu-item">
        @if (!navigationItem.children?.length) {
        <user-interaction
          [interaction]="navigationItem.userInteraction"
          [matTooltip]="navigationItem.label"
          matTooltipPosition="below"
          [matTooltipDisabled]="!userNotificationTooltipVisible"
          (click)="toggleNotificationTooltip()"
        >
          <div class="topbar-meta_menu-item-icon">
            <hls-icon
              [icon]="navigationItem.icon | removeHeliosIconPrefix"
            ></hls-icon>
            @if (!!navigationItem.badge) {
            <navigation-badge
              class="navigation-badge--floating navigation-badge--small"
              [badge]="navigationItem.badge"
            ></navigation-badge>
            }
          </div>
        </user-interaction>
        } @if (navigationItem.children?.length) {
        <hls-menu align="right" (click)="toggleUsersettingsTooltips()">
          <hls-icon
            [icon]="navigationItem.icon"
            slot="toggle"
            [matTooltip]="navigationItem.label"
            matTooltipPosition="below"
            [matTooltipDisabled]="!userSettingsTooltipVisible"
          ></hls-icon>
          @for (childNavigationItem of navigationItem.children; track
          childNavigationItem) {
          <div slot="entry">
            <user-interaction
              [interaction]="childNavigationItem.userInteraction"
            >
              <hls-icon [icon]="childNavigationItem.icon"></hls-icon>
              <span [innerText]="childNavigationItem.label"></span>
              @if (childNavigationItem?.suffixIcon) {
              <hls-icon
                class="suffix-icon"
                [icon]="childNavigationItem?.suffixIcon"
              ></hls-icon>
              }
            </user-interaction>
          </div>
          }
        </hls-menu>
        }
      </li>
      }
    </ul>
  </nav>
</div>
